<template>
  <div class='assessment-chart' ref="assessmentChart"></div>
</template>

<script>
import * as echarts from 'echarts'
import _ from 'lodash'
import { mapActions } from 'vuex'
import { SQUARED_UP_MAP } from '@/constant/application'

const color = {
  low: 'rgba(234,127,127,0.6)',
  medium: 'rgba(244,169,88,0.6)',
  high: 'rgba(81,191,130,0.6)'
}

// const itemStyle = {
//   opacity: 0.8,
//   shadowBlur: 10,
//   shadowOffsetX: 0,
//   shadowOffsetY: 0,
//   shadowColor: 'rgba(0,0,0,0.3)'
// }

const fgX = 57
const fgY = 183
const spW = 68
const spH = 63

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true,
      default: () => []
    },
    jobId: {
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      highFitList: [],
      midFitList: [],
      lowFitList: [],
      chart: null,
      squaredUpColor: {
        1: '#fff',
        2: '#fff',
        3: '#fff',
        4: '#fff',
        5: '#fff',
        6: '#fff',
        7: '#fff',
        8: '#fff',
        9: '#fff'
      }
    }
  },
  computed: {
    option () {
      const option = {
        color: [color.high, color.medium, color.low],
        legend: {
          data: ['High', 'Medium', 'Low'],
          textStyle: {
            fontSize: 12
          },
          right: 0,
          itemWidth: 8,
          selectedMode: false
        },
        grid: {
          left: 23,
          right: 5,
          top: 25,
          bottom: 25
        },
        // tooltip: {
        //   backgroundColor: 'rgba(255,255,255,0.7)',
        //   formatter: function (param) {
        //     var value = param.value
        //     return `<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 12px; white-space: pre-wrap">${value}</div>`
        //   }
        // },
        graphic: [{
          type: 'group',
          children: [
            {
              id: 1,
              type: 'group',
              x: fgX,
              y: fgY,
              children: [
                {
                  id: '1.1',
                  type: 'rect',
                  left: 'center', // 相对父元素居中
                  top: 'middle', // 相对父元素居中
                  shape: {
                    width: spW,
                    height: spH
                  },
                  style: {
                    fill: this.squaredUpColor[1]
                  }
                }
              ]
            },
            {
              id: 2,
              type: 'group',
              x: fgX + spW,
              y: fgY,
              children: [
                {
                  id: '2.1',
                  type: 'rect',
                  left: 'center', // 相对父元素居中
                  top: 'middle', // 相对父元素居中
                  shape: {
                    width: spW,
                    height: spH
                  },
                  style: {
                    fill: this.squaredUpColor[2]
                  }
                }
              ]
            },
            {
              id: 3,
              type: 'group',
              x: fgX + 2 * spW,
              y: fgY,
              children: [
                {
                  id: '3.1',
                  type: 'rect',
                  left: 'center', // 相对父元素居中
                  top: 'middle', // 相对父元素居中
                  shape: {
                    width: spW,
                    height: spH
                  },
                  style: {
                    fill: this.squaredUpColor[3]
                  }
                }
              ]
            },
            {
              id: 4,
              type: 'group',
              x: fgX,
              y: fgY - spH,
              children: [
                {
                  id: '4.1',
                  type: 'rect',
                  left: 'center', // 相对父元素居中
                  top: 'middle', // 相对父元素居中
                  shape: {
                    width: spW,
                    height: spH
                  },
                  style: {
                    fill: this.squaredUpColor[4]
                  }
                }
              ]
            },
            {
              id: 5,
              type: 'group',
              x: fgX + spW,
              y: fgY - spH,
              children: [
                {
                  id: '5.1',
                  type: 'rect',
                  left: 'center', // 相对父元素居中
                  top: 'middle', // 相对父元素居中
                  shape: {
                    width: spW,
                    height: spH
                  },
                  style: {
                    fill: this.squaredUpColor[5]
                  }
                }
              ]
            },
            {
              id: 6,
              type: 'group',
              x: fgX + 2 * spW,
              y: fgY - spH,
              children: [
                {
                  id: '6.1',
                  type: 'rect',
                  left: 'center', // 相对父元素居中
                  top: 'middle', // 相对父元素居中
                  shape: {
                    width: spW,
                    height: spH
                  },
                  style: {
                    fill: this.squaredUpColor[6]
                  }
                }
              ]
            },
            {
              id: 7,
              type: 'group',
              x: fgX,
              y: fgY - 2 * spH,
              children: [
                {
                  id: '7.1',
                  type: 'rect',
                  left: 'center', // 相对父元素居中
                  top: 'middle', // 相对父元素居中
                  shape: {
                    width: spW,
                    height: spH
                  },
                  style: {
                    fill: this.squaredUpColor[7]
                  }
                }
              ]
            },
            {
              id: 8,
              type: 'group',
              x: fgX + spW,
              y: fgY - 2 * spH,
              children: [
                {
                  id: '8.1',
                  type: 'rect',
                  left: 'center', // 相对父元素居中
                  top: 'middle', // 相对父元素居中
                  shape: {
                    width: spW,
                    height: spH
                  },
                  style: {
                    fill: this.squaredUpColor[8]
                  }
                }
              ]
            },
            {
              id: 9,
              type: 'group',
              x: fgX + 2 * spW,
              y: fgY - 2 * spH,
              children: [
                {
                  id: '9.1',
                  type: 'rect',
                  left: 'center', // 相对父元素居中
                  top: 'middle', // 相对父元素居中
                  shape: {
                    width: spW,
                    height: spH
                  },
                  style: {
                    fill: this.squaredUpColor[9]
                  }
                }
              ]
            }
          ]
        }],
        xAxis: {
          type: 'value',
          name: this.$t(`${this.i18nPrefix}.label.filter.personalityFit`),
          nameLocation: 'middle',
          nameGap: 12,
          nameTextStyle: {
            fontSize: 12
          },
          max: 10,
          interval: 3.33,
          splitLine: {
            show: true
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t(`${this.i18nPrefix}.label.filter.cultureFit`),
          nameLocation: 'middle',
          nameGap: 8,
          max: 10,
          interval: 3.33,
          nameTextStyle: {
            fontSize: 12
          },
          splitLine: {
            show: true
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        visualMap: [
          {
            dimension: 2,
            calculable: false,
            precision: 0.1,
            show: false,
            inRange: {
              symbolSize: [10, 30] // 图表上点的大小范围
            }
          }
        ],
        series: [
          {
            name: 'High',
            type: 'scatter',
            data: this.highFitList
          },
          {
            name: 'Medium',
            type: 'scatter',
            data: this.midFitList
          },
          {
            name: 'Low',
            type: 'scatter',
            data: this.lowFitList
          },
          // 没有数据的时候，网格能够显示
          {
            name: 'default',
            type: 'scatter',
            symbol: 'none',
            data: [0]
          }
        ]
      }
      return option
    }
  },
  created () {

  },
  mounted () {
    this.loadCandidateFit()
  },
  methods: {
    ...mapActions('application', ['getAssessmentFitCount']),
    async loadCandidateFit () {
      const resp = await this.getAssessmentFitCount({ job_id: this.jobId })
      if (resp) {
        _.forEach(resp, (item, index) => {
          let squaredUpKey = ''
          _.forEach(SQUARED_UP_MAP, (fitItem, key) => {
            const { personalityFit, cultureFit } = fitItem
            const checked = item.job_fit >= personalityFit[0] &&
              item.job_fit < personalityFit[1] &&
              item.organization_fit >= cultureFit[0] &&
              item.organization_fit < cultureFit[1]
            if (checked) {
              squaredUpKey = key
              return false
            }
          })
          const score = (item.job_fit + item.organization_fit) / 2
          const info = {
            value: [item.job_fit, item.organization_fit, item.count],
            itemStyle: {
              color: this.getColor([item.job_fit, item.organization_fit])
            },
            cultureFit: item.organization_fit,
            personalityFit: item.job_fit,
            id: index,
            key: squaredUpKey
          }
          if (score < 30) {
            this.lowFitList.push(info)
          } else if (score < 60) {
            this.midFitList.push(info)
          } else {
            this.highFitList.push(info)
          }
        })
      }
      this.$nextTick(() => {
        this.initAssessmentChart()
      })
    },
    getColor (value) {
      const score = (value[0] + value[1]) / 2
      if (score < 3) {
        return color.low
      } else if (score < 6) {
        return color.medium
      } else {
        return color.high
      }
    },
    initAssessmentChart () {
      const vm = this
      const el = this.$refs.assessmentChart
      this.chart = echarts.init(el)
      const chart = this.chart
      chart.setOption(this.option)

      chart.on('click', params => {
        if (params.seriesName === 'default') {
          return
        }
        const id = params.componentType === 'graphic' ? params.event.target.parent.id : params.data.key
        // const id = params.event.target.parent.id
        const index = _.findIndex(vm.value, item => item.type === 'squared_up' && item.id === id)
        if (index > -1) {
          vm.value.splice(index, 1)
        } else {
          vm.value.push({
            type: 'squared_up',
            id
          })
        }
        const data = _.chain(vm.value).filter(item => item.type === 'squared_up').map(item => item.id).value()
        _.forEach(SQUARED_UP_MAP, (item, key) => {
          if (!_.includes(data, key)) {
            vm.squaredUpColor[key] = '#dbdbdb'
          } else {
            vm.squaredUpColor[key] = '#fff'
          }
        })
        // }
        // } else {
        // 点击单个气泡
        // const seriesIndex = params.seriesIndex
        // const dataIndex = params.dataIndex
        // const data = option.series[seriesIndex].data[dataIndex] // 获取被点击的气泡的数据
        // vm.value.push(data)

        // _.forEach(SQUARED_UP_MAP, (item, key) => {
        //   const { personalityFit, cultureFit } = item
        //   const data = params.data
        //   const checked = data.personalityFit >= personalityFit[0] &&
        //     data.personalityFit <= personalityFit[1] &&
        //     data.cultureFit >= cultureFit[0] &&
        //     data.cultureFit <= cultureFit[1]
        //   const index = _.findIndex(vm.value, item => item.type === 'squared_up' && item.id === key)
        //   if (index > -1) {
        //     vm.value.splice(index, 1)
        //   } else if (checked) {
        //     vm.value.push({
        //       type: 'squared_up',
        //       id: key
        //     })
        //   }
        // })
        // }
        vm.$emit('change', vm.value)
        chart.setOption(this.option)
      })
    },
    resetChart () {
      // const fitList = _.concat(this.lowFitList, this.midFitList, this.highFitList)
      // if (this.value.length > 0) {
      //   _.forEach(fitList, fit => {
      //     if (!_.some(this.value, item => fit.id === item.id)) {
      //       fit.itemStyle = { color: '#dbdbdb' }
      //       fit.emphasis = { itemStyle: { color: '#dbdbdb' } }
      //     } else {
      //       const color = this.getColor(fit.value)
      //       fit.itemStyle = { color }
      //       fit.emphasis = { itemStyle: { color } }
      //     }
      //   })
      // } else {
      //   _.forEach(fitList, fit => {
      //     const color = this.getColor(fit.value)
      //     fit.itemStyle = { color }
      //     fit.emphasis = { itemStyle: { color } }
      //   })
      // }

      if (this.value.length < 1) {
        _.forEach(SQUARED_UP_MAP, (item, key) => {
          this.squaredUpColor[key] = '#fff'
        })
      } else {
        _.forEach(SQUARED_UP_MAP, (item, key) => {
          if (!_.some(this.value, item => item.id === key)) {
            this.squaredUpColor[key] = '#dbdbdb'
          } else {
            this.squaredUpColor[key] = '#fff'
          }
        })
      }
      this.chart.setOption(this.option)
    }
  },
  watch: {
    '$i18n.locale' () {
      this.resetChart()
    },
    value () {
      this.resetChart()
    }
  }
}
</script>
<style lang='scss' scoped>
.assessment-chart {
  width: 100%;
  height: 240px;
}
</style>
